
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Menu, X, PlusCircle } from 'lucide-react';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-navy shadow-md text-white transition-all duration-300">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2 group">
          <div className="bg-white/10 p-1.5 rounded-lg group-hover:bg-white/20 transition duration-300">
            <Home className="text-orange animate-pulse" size={24} />
          </div>
          <div className="flex flex-col">
            <span className="text-2xl font-bold tracking-tight leading-none group-hover:text-orange transition duration-300">LDF</span>
            <span className="text-[10px] text-gray-300 tracking-wider uppercase">Le Démarcheur Facilitateur</span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8">
          <Link to="/" className={`hover:text-orange transition duration-300 ${isActive('/') ? 'text-orange font-semibold' : ''}`}>Accueil</Link>
          <Link to="/nos-biens" className={`hover:text-orange transition duration-300 ${isActive('/nos-biens') ? 'text-orange font-semibold' : ''}`}>Nos Biens</Link>
          <Link to="/nos-services" className={`hover:text-orange transition duration-300 ${isActive('/nos-services') ? 'text-orange font-semibold' : ''}`}>Nos Services</Link>
          <Link to="/qui-nous-sommes" className={`hover:text-orange transition duration-300 ${isActive('/qui-nous-sommes') ? 'text-orange font-semibold' : ''}`}>Qui nous sommes ?</Link>
        </nav>

        <div className="hidden md:block">
           <Link to="/publier" className="border border-orange text-orange hover:bg-orange hover:text-white px-5 py-2 rounded-full font-medium transition duration-300 flex items-center shadow-sm hover:shadow-lg">
             <PlusCircle size={18} className="mr-2" />
             Publier un bien
           </Link>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-1 text-white" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMenuOpen && (
        <div className="md:hidden bg-navy border-t border-white/10 animate-in slide-in-from-top-2 duration-200">
          <nav className="flex flex-col p-4 space-y-4">
            <Link to="/" className="block py-2 hover:text-orange border-b border-white/5" onClick={() => setIsMenuOpen(false)}>Accueil</Link>
            <Link to="/nos-biens" className="block py-2 hover:text-orange border-b border-white/5" onClick={() => setIsMenuOpen(false)}>Nos Biens</Link>
            <Link to="/nos-services" className="block py-2 hover:text-orange border-b border-white/5" onClick={() => setIsMenuOpen(false)}>Nos Services</Link>
            <Link to="/qui-nous-sommes" className="block py-2 hover:text-orange border-b border-white/5" onClick={() => setIsMenuOpen(false)}>Qui nous sommes ?</Link>
            <Link to="/publier" className="block py-2 text-orange font-bold mt-2" onClick={() => setIsMenuOpen(false)}>Publier un bien</Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
